import styled, { css } from "styled-components";
import { Field } from "formik";
import { getParagraph16RegularTypography } from "../../Typography/Paragraph16";
import { getMediumTypography } from "../../Typography/helpers";

export const getFormInputStyles = css`
  width: 100%;
  height: 44px;
  background: ${({ theme }) => theme.inputBackgroundColor};
  border: 1px solid ${({ theme }) => theme.inputBorderColor};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  ${getParagraph16RegularTypography};
  line-height: 18px;
  color: ${({ theme }) => theme.primaryColor};
  opacity: 0.8;
  padding-left: 15px;
  box-sizing: border-box;
  outline: none;

  && {
    ::placeholder {
      ${getMediumTypography};
      color: ${({ theme }) => theme.lightBorderColor};
      font-size: ${({ theme }) => theme.paragraph.md};
      line-height: 16px;
    }

    &:focus,
    &:hover {
      border-color: ${({ theme }) => theme.primaryColor};
    }
  }

  &:disabled {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const FormInput = styled(Field)`
  ${getFormInputStyles};
`;

export default FormInput;
